import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { ReactNode } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { formatDecimal } from '../../utils';
import styles from './MoneyPercentageIndicator.module.scss';

export interface IMoneyPercentageIndicator {
  value?: number | null;
  newObjectiveMargin?: number | null;
  className?: string;
  tooltip?: string;
}

type IconTooltip = {
  icon: ReactNode;
  tooltip?: string;
};

const TooltipIndicator = ({ icon, tooltip = 'Filtrar por fator margem' }: IconTooltip) => (
  <Whisper placement="auto" trigger="hover" speaker={<Tooltip>{tooltip}</Tooltip>}>
    {icon}
  </Whisper>
);

export const MoneyPercentageIndicator = ({ value, newObjectiveMargin, className, tooltip }: IMoneyPercentageIndicator) => {
  const iconStatus = newObjectiveMargin && value ? (newObjectiveMargin > value ? 'icon-negative' : 'icon-default') : 'icon-default';
  const textStatus = newObjectiveMargin && value ? (newObjectiveMargin > value ? 'text-negative' : 'text-default') : 'text-default';

  return (
    <div className={[styles['indicator-wrapper'], className].join(' ')}>
      <TooltipIndicator icon={<AttachMoneyIcon className={styles[value !== null ? iconStatus : 'icon-default']} />} tooltip={tooltip} />
      {value !== null ? <p className={styles[textStatus]}>{value ? formatDecimal(value, 1) : '--'} %</p> : <p className={styles['text-default']}>--</p>}
    </div>
  );
};
